export default {
  processing: false,
  error: null,
  success: null,
  // navbar contact text (ContactInfo.vue) -- loaded once per page load
  contactInfo: '',
  contactInfoLoaded: false,
}
